export default __webpack_public_path__ + "static/media/12.8e07fec0.png";